// extracted by mini-css-extract-plugin
export default {"cell":"mcUiK","lessonsStructureCell":"n9v8P","iconWrapper":"Lfx9D","icon":"xKITv","inner":"XgTjo","title":"Thbr2"};